import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoryService } from 'src/app/services/category.service';
import { CommonService } from 'src/app/services/common.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';

@Component({
  selector: 'calosft-sub-category-final',
  templateUrl: './sub-category-list.component.html',
  styleUrls: ['./sub-category-list.component.scss']
})
export class SubCategoryListComponent implements OnInit {

  @Input() categories;
  @Input() categoryParentId;
  @Output() change: EventEmitter<any> = new EventEmitter();
  mainCategories:any=[];

  @Input() data;

  constructor(public categoryService: CategoryService,
    public activatedRoute: ActivatedRoute,
    private ecryptServiceService: EcryptServiceService,
    private commonService:CommonService
    ){
    
  }

  ngOnInit(): void {

    this.getCategoryData();
      
  }

  getCategoryData() {

    let value = this.activatedRoute.snapshot.queryParamMap.get('sid');
    this.categoryService.fetchByParentCategoryId(value).subscribe(
      res => {
          this.mainCategories = res;
      }, error => {

      }
  )
  }

  goToCategory(menu) {
    this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);

  }


}
